import React, { useEffect } from 'react';

import { useProgress } from 'ui-components/hooks/use-progress';
import { ProgressBar } from 'ui-components/components/progress-bar';

import style from './modal-footer-progress-bar.module.css';
import PropTypes from 'prop-types';

const ModalFooterProgressBar = ({ estimatedMilliseconds = 0, theme = 'create' }) => {
  const { percentageComplete, startProgress, resetProgress } = useProgress(estimatedMilliseconds);

  useEffect(() => {
    if (estimatedMilliseconds) {
      startProgress();
    }
    return () => {
      if (estimatedMilliseconds) {
        resetProgress();
      }
    };
  }, [startProgress, resetProgress, estimatedMilliseconds]);

  return (
    <div className={style['progress-bar']}>
      <ProgressBar indefiniteProgress={!estimatedMilliseconds} percentageComplete={percentageComplete || 0} theme={theme} />
    </div>
  );
};

export { ModalFooterProgressBar };

ModalFooterProgressBar.propTypes = {
  estimatedMilliseconds: PropTypes.number,
  theme: PropTypes.oneOf(['primary', 'create', 'danger']),
};
